import React from 'react';

import type { Content } from '../../types';

import { Author } from './Author';
import { Description } from './Description';
import { Duration } from './Duration';
import {
  Container,
  HeroWrapper,
  HeroBlock,
  HeroTextBlock,
  MetaInfoContainer,
  TitleAndAuthorContainer,
  HeroContainer,
} from './elements';
import { getDurationInMinutes } from './getDurationInMinutes';
import { Hero } from './Hero';
import { RelatedLinks } from './RelatedLinks';
import { ShareIcons } from './ShareIcons';
import { Title } from './Title';

interface Props {
  content: Content;
}

export const Details: React.FC<Props> = ({ content }) => {
  return (
    <Container>
      <HeroWrapper>
        <HeroContainer>
          <HeroBlock>
            <Hero content={content} />
          </HeroBlock>
          <HeroTextBlock>
            <TitleAndAuthorContainer>
              <Title content={content} />
              <Author teacher={content.teacher} />
            </TitleAndAuthorContainer>
            <MetaInfoContainer>
              <RelatedLinks content={content} />
              <Duration minutes={getDurationInMinutes(content)} />
            </MetaInfoContainer>
          </HeroTextBlock>
        </HeroContainer>
      </HeroWrapper>
      <ShareIcons content={content} />
      <Description content={content} />
    </Container>
  );
};
